import { LoginCallback } from '@okta/okta-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useEventTracking } from '../../hooks'

function LoginCallbackErrorRedirect({ error: _error }: { error: Error }) {
  const navigate = useNavigate()
  const { trackError } = useEventTracking('Login Callback Redirect')

  useEffect(() => {
    trackError({
      event: 'Okta Callback Failed',
      error: _error,
    })
    navigate('/login', { replace: true })
  }, [navigate, trackError, _error])

  return null
}

export function LoginCallbackRedirect() {
  return <LoginCallback errorComponent={LoginCallbackErrorRedirect} />
}

